import styled, { css } from 'styled-components'

export const FileDownloadButton = styled.button`
  padding: 0;
  border: 0;
  background: transparent;
  color: ${({ theme }) => theme.colors.blue500};
  text-decoration: underline;
  cursor: pointer;
`

export const ProvidersContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: ${theme.space['12']};
    padding: ${theme.space['8']} ${theme.space['0']};
  `,
)

/* Note: Add styling for dangerouslySetInnerHTML */
export const InnerHtmlContainer = styled.div(
  ({ theme }) => css`
    padding: ${theme.space['8']} ${theme.space['0']};

    h1 {
      font-size: 1.6rem;
      font-weight: 500;
      line-height: 2.8rem;
    }

    h2 {
      font-size: 1.4rem;
      font-weight: 500;
      line-height: 2.4rem;
    }

    li {
      margin-left: ${theme.space['20']};
    }

    blockquote {
      padding: ${theme.space['4']} ${theme.space['8']};
      border-left: ${theme.border.size['2']} solid ${theme.colors.primary600};
    }

    .ql-indent-1 {
      margin-left: ${theme.space['16']};
    }
  `,
)
